import { getAlgoliaResults } from "@algolia/autocomplete-js";
import { useI18n } from "vue-i18n";
import { useLanguages } from "@/core/composables";
import { prefixLocaleUrl } from "@/core/utilities";
import { getIndexName } from "@/shared/thorlabs/search";
import { searchClient } from "./searchClient";
import type { IAlgoliaSoftwarePage } from "../searchTypes";

export function getSoftwarePagesPlugin() {
  const { t } = useI18n();

  const { currentLocale, defaultLocale } = useLanguages();
  const softwareDownloadsIndexName = getIndexName("softwarepages", currentLocale.value);

  return {
    getSources({ query }: { query: string }) {
      if (!query) {
        return [];
      }
      return [
        {
          sourceId: "softwarePages",
          getItems() {
            return getAlgoliaResults({
              searchClient: searchClient.value,
              queries: [
                {
                  indexName: softwareDownloadsIndexName,
                  params: {
                    query,
                    hitsPerPage: 3,
                    attributesToSnippet: ["name:10"],
                    snippetEllipsisText: "…",
                  },
                },
              ],
            });
          },
          templates: {
            header({ html }: { html: (literals: TemplateStringsArray, ...placeholders: unknown[]) => string }) {
              return html`<h6>
                <svg class="vc-icon shrink-0">
                  <use href="/static/thorlabs/icons/basic/download.svg?#icon"></use>
                </svg>
                ${t("autocomplete.search.software_downloads")}
              </h6>`;
            },
            item({
              item,
              html,
            }: {
              html: (literals: TemplateStringsArray, ...placeholders: unknown[]) => string;
              item: IAlgoliaSoftwarePage;
            }) {
              return html` <span class="aa-ItemContent aa-ItemContent--link">
                <a
                  href=${prefixLocaleUrl(item.url, currentLocale.value, defaultLocale.value)}
                  onClick=${() => {
                    const event = new CustomEvent("closeSearchDropdown");
                    document.dispatchEvent(event);
                  }}
                >
                  <span dangerouslySetInnerHTML=${{ __html: item.title }}></span
                ></a>
              </span>`;
            },
            noResults() {
              return t("autocomplete.search.software_downloads");
            },
          },
        },
      ];
    },
  };
}
